"use client"

import {ISchoolFeedUrlQueries} from "../../utils/SchoolBlocksUtilities";
import {observer} from "mobx-react";
import styles from "./styles/SchoolFeedDisplay.module.scss";
import ContentItemGrid from "../grids/ContentItemGrid";
import widgetStyles from "./styles/SchoolFeedWidget.module.scss";
import Button from "../utilities/Button";
import FontAwesome from "../utilities/FontAwesome";
import classNames from 'classnames';
import {useSchoolFeedInfiniteScroll} from "./hooks/useSchoolFeedInfiniteScroll";
import {InitialLoadingIndicatorWrapper} from "./InitialLoadingIndicatorWrapper";
import {useTrackVisibility} from "../../hooks/useTrackVisibility";

const SchoolFeedCourseworkDisplay: React.FC<{
    urlQuery: ISchoolFeedUrlQueries,
}> = observer((props) => {

    const {
        contentItems,
        totalContentItems,
        getItemAtIndex,
        showViewMore,
        isLoading,
        isValidating,
        size,
        setSize,
        error
    } = useSchoolFeedInfiniteScroll(
        "coursework",
        {
            is_coursework: true,
        }
    )

    const infiniteScrollRef = useTrackVisibility(() => setSize(s => s + 1),
        {
        dependencies: [totalContentItems],
    })

    const loadingMsgClassName = classNames({
        'sb-content-width': true,
        'sb-no-filter-results-msg': true,
        'active': isValidating,
    });

    return <InitialLoadingIndicatorWrapper
        initialFetchIsLoading={contentItems.length === 0 && isLoading}
        dataSize={contentItems.length}
        errorCode={error?.status}
        showInitialLoadingIndicator={true}
    >
        <div>
            <div className={styles.feedContainer}>
                <div className={`sb-grid-wrapper`}>
                    <div id="main-grid-container" className={"sb-main-content sb-content-width-plus-margin"}>
                        <ContentItemGrid
                            contentItems={contentItems}
                            getItemAtIndex={getItemAtIndex}
                            totalItemCount={totalContentItems}
                        />
                    </div>
                </div>
            </div>
            {showViewMore && <>
                {process.env.NEXT_PUBLIC_APP_CTX === "schoolfeed" ? <>
                        <div ref={infiniteScrollRef}/>
                        <div className={loadingMsgClassName}>
                            <div>
                                <FontAwesome prefix={"fas"} name={"fa-spinner"} spin={true}/>
                            </div>
                        </div>
                    </> :
                    <div style={{marginTop: "2rem"}} className={widgetStyles.fetchMoreContainer}>
                        <Button disabled={isValidating}
                                onClick={() => setSize(size + 1)}>{isValidating ?
                            <FontAwesome name={'fas fa-spinner'} spin/> : "View More"}</Button></div>
                }
            </>}
        </div>
    </InitialLoadingIndicatorWrapper>
})

export default SchoolFeedCourseworkDisplay;
